import React from 'react'
import { Box } from 'reactjs-admin-lte'
import ReactPaginate from 'react-paginate'
import {Button,ButtonToolbar,Row,Col,FormControl,Popover,OverlayTrigger,DropdownButton,MenuItem,Breadcrumb} from 'react-bootstrap'
import POOutstandingRecordModal from '../po/POOutstandingRecordModal'
import Select from 'react-select'
import WorkdocStore from '../../stores/WorkdocStore'
import FontAwsome from 'react-fontawesome'
import SupplierPageModal from '../po/SupplierPageModal'
import PurchaseOrderDoc from '../po/PurchaseOrderDoc'
import $ from 'jquery';
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import { Checkbox } from 'react-icheck';
const TODAY = Moment().format('L').replace(Moment().format('YYYY'), Moment().format('YYYY'));
var numberFormat = require('number-format.js')
var NotificationSystem = require('react-notification-system');

class WorkDocPurchaseOrder extends React.Component {
  constructor(props) {
    super(props)
    this.headerTitles = {
      seq: 'ลำดับ',
      itemName: 'รายการอะไหล่',
      quantity: 'จำนวน',
      itemTypeId: 'ประเภท',
      shopName: 'ร้านที่สั่ง',
      purchaseOrder: 'ใบสั่งซื้อ',
      issueDate: 'วันที่ออกเอกสาร',
      statusId: 'สถานะสั่งซื้อ',
      delete: 'ลบ'
    }
    this.state = {
      showShop:false,
      editIndex:-1,
      loading:false,
      pageCount:1,
      activePage:1,
      data:{dataList:[],itemTypes:[],status:[]},
      doc:{purchase_order_no:'',exportwork_date:'',received_date:'',importstock_date:''},
      showTable:true,
      summary:{po_amount_before_discount:0,po_discount:0,po_amount:0},
      part_dispose:[],
      showPOR:false,
      showPOT:false,
      showPOE:false,
      showPOI:false,
      poNo:null
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()

    $('body').on('click', ()=> { 
      if ($('.Select').hasClass('is-open'))
        $('.table-responsive').css( "overflow-x", "initial" );
      else
        $('.table-responsive').css( "overflow-x", "auto" );
    });
  } 

  loadData(){
    let that = this
    let {part_dispose} = this.state
    WorkdocStore.loadWorkdocPurchaseOrder(this.props.workNo, (result) => {
      let data = {dataList:[],itemTypes:[],status:[]}
      let summary = {po_amount_before_discount:0,po_discount:0,po_amount:0}
      data.dataList = result.data.map((item,index)=>{
        const po_amount_before_discount = (item.po_amount*1+item.po_discount*1)
        summary.po_amount_before_discount += po_amount_before_discount
        summary.po_discount += item.po_discount*1
        summary.po_amount += item.po_amount*1
        return(
          {
            id:item.bf_work_damage_id,
            itemName:item.detail,
            quantity:item.quantity,
            itemTypeId:item.part_type,
            shopName:item.shop_name,
            shopId:item.shop_id,
            purchaseOrder:item.purchase_order_no,
            issueDate:item.po_date,
            statusId:item.po_status,
            remark:item.remark,
            po_received_date:item.po_received_date,
            po_amount_before_discount:po_amount_before_discount,
            po_discount:item.po_discount,
            po_amount:item.po_amount,
            exportwork_date:item.exportwork_date,
            import_stock_date:item.import_stock_date,
            payment_date:item.payment_date,
            amount:item.amount,
            part_by:item.part_by,
            part_dispose_by:item.part_dispose_by,
            is_pending_install:item.is_pending_install,
            productcode:item.productcode
          }
        )
      })
      data.itemTypes = result.itemTypes
      data.status  = result.status
      part_dispose = result.part_dispose.map((item,index)=>{
        return {label:item.title,value:item.value}
      })

      that.setState({ part_dispose: part_dispose, loading: false, data: data,summary:summary,status:result.status,itemTypes:result.itemTypes })
    })
  }

  onPlusClick(index){
    this.setState({showShop:true,editIndex:index})
  }

  onSupplierPageSelect(item){

    let {data,editIndex} = this.state
    data.dataList[editIndex].shopName = item.name;
    this.setState({data:data,editIndex:-1})
  }

  onPartByChange(index,e) {
    let {data} = this.state
    data.dataList[index].part_by = e.value
    this.setState({data:data})
    $('.table-responsive').css( "overflow-x", "auto" );
  }

  onSaveClick(){
    let {data} = this.state
    let items = data.dataList.map((item,index)=>{
      return (
        {
          bf_work_damage_id:item.id,
          detail:item.itemName,
          quantity:item.quantity,
          part_type:item.itemTypeId,          
          shop_id:item.shopId,  
          remark:item.remark,
          exportwork_date:item.exportwork_date,
          amount:item.amount,
          part_by:item.part_by,
          part_dispose_by:item.part_dispose_by,
          is_pending_install:item.is_pending_install,
          productcode:item.productcode
        }
      )
    })
    let that = this
    let workNo = this.props.workNo
    WorkdocStore.saveWorkdocPurchase(this.props.workNo,items,function(result){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียด ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      });
      that.loadData()
    },function(){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'พบปัญหาการบันทึก ' + workNo + ' ',
        level: 'error',
        position: 'tc',        
      });
    })
  }

  onRowSelect(item){
    this.setState({showTable:false,poNo:item.purchaseOrder})
    this.refs.poDoc.getWrappedInstance().loadData(item.purchaseOrder)
    if(this.props.onDocShow!==undefined){
      this.props.onDocShow(item.purchaseOrder)
    }
  }

  onPartDisposeByChange(index,e) {
    let {data} = this.state
    if (e!==null) {
      data.dataList[index].part_dispose_by = e.value
    } else {
      data.dataList[index].part_dispose_by = ''
    }
    this.setState({data:data})
  }

  onDocClose() {
    this.setState({showTable:true})
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
    this.loadData()
  }

  onPullLatestQuotation() {
    let {data} = this.state
    this.setState({loading:true})
    WorkdocStore.loadLatestQuotationPart(this.props.workNo,(result)=>{
      result.data.forEach((item,index)=>{
        let keyPart =  data.dataList.findIndex(x=>x.itemName===item.detail)
        if (keyPart!==-1) {
          data.dataList[keyPart].itemTypeId = (item.approved_part_type==='original_part'?'originalPrice':item.approved_part_type==='similar_part'?'similarPrice':item.approved_part_type==='old_part'?'oldPartPrice':item.approved_part_type)
          data.dataList[keyPart].part_by = item.part_by
          data.dataList[keyPart].productcode = item.productcode
        }else{
          item = Object.assign(this.newEmptyRow(1)[0],item)
          item.itemName = item.detail
          item.itemTypeId = (item.approved_part_type==='original_part'?'originalPrice':item.approved_part_type==='similar_part'?'similarPrice':item.approved_part_type==='old_part'?'oldPartPrice':item.approved_part_type)
          data.dataList.push(item)
        }
      })
      this.setState({loading:false,data:data})
    },()=>{
      this.setState({loading:false})
    })
  }

  renderTable() {
    // add row sequence, translate ids to titles
    // const mappingColumns = ['itemTypeId', 'statusId']
    // const rows = this.state.data.dataList.map((row, idx) => {
    //   const copiedRow = Object.assign({}, row)
    //   copiedRow.itemTypeId =
    //     this.state.data.itemTypes.filter((itemType) =>
    //       row.itemTypeId === itemType.itemTypeId
    //     )[0].title
    //   copiedRow.statusId =
    //     this.state.data.status.filter((theStatus) =>
    //       row.statusId === theStatus.statusId
    //     )[0].title

    //   copiedRow['seq'] = idx + 1
    //   return copiedRow
    // })
    let {summary} = this.state
    return (
      <div className='table-responsive' >
        <table className='table table-hover table-bordered-solid' style={{minWidth:'2650px',marginBottom:'0'}}>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th rowSpan={2} className='text-center' style={{width:'150px'}}>รหัสอะไหล่</th>
              <th rowSpan={2} className='text-center' style={{width:'350px'}}>รายการอะไหล่</th>
              <th rowSpan={2} className='text-center' style={{width:'80px'}}>จำนวน</th>
              <th rowSpan={2} className='text-center' style={{width:'130px'}}>ประเภท</th>
              <th rowSpan={2} className='text-center' style={{width:'150px'}}>ผู้จัดอะไหล่</th>
              <th rowSpan={2} className='text-center' style={{width:'150px'}}>คืนซาก</th>
              <th rowSpan={2} className='text-center' style={{width:'100px'}}>ค้างติดตั้งอะไหล่</th>
              <th rowSpan={2} className='text-center' style={{width:'150px'}}>ร้านที่สั่ง</th>
              <th colSpan={3} className='text-center'>ราคา</th>
              <th rowSpan={2} className='text-center' style={{width:'150px'}}>ใบสั่งซื้อ</th>
              <th colSpan={7} className='text-center'>สถานะ</th>
              <th rowSpan={2} className='text-center' style={{width:'300px'}}>หมายเหตุ</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'90px'}}>ก่อนส่วนลด</th>
              <th className='text-center' style={{width:'90px'}}>ส่วนลด</th>              
              <th className='text-center' style={{width:'90px'}}>รวมทั้งสิ้น</th>
              <th className='text-center' style={{width:'150px'}}>วันออกเอกสาร</th>
              <th className='text-center' style={{width:'150px'}}>วันที่อนุมัติ</th>
              <th className='text-center' style={{width:'150px'}}>วันที่ <br /> รับอะไหล่เข้า</th>
              <th className='text-center' style={{width:'150px'}}>วันที่ <br /> เบิกซ่อม</th>
              <th className='text-center' style={{width:'150px'}}>วันที่ <br /> นำสินค้าเข้าคลัง</th>
              <th className='text-center' style={{width:'110px'}}>ชำระเงินแล้ว</th>
              <th className='text-center' style={{width:'150px'}}>สถานะสั่งซื้อ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={9} className='text-right'>
                รวมเป็นเงิน
              </th>
              <th className='text-right'>{numberFormat("#,##0.##",summary.po_amount_before_discount)}</th>    
              <th className='text-right'>{numberFormat("#,##0.##",summary.po_discount)}</th>    
              <th className='text-right'>{numberFormat("#,##0.##",summary.po_amount)}</th>
              <th className='text-right'></th> 
              <th className='text-right'></th> 
              <th className='text-right'></th> 
              <th className='text-right'></th> 
              <th className='text-right'></th> 
              <th className='text-right'></th> 
              <th className='text-right'></th> 
              <th className='text-right'></th>
              <th className='text-right'></th>                         
            </tr>
          </tfoot>
        </table>
      </div>  
    )
  }

  renderStatus(statusId) {
    
    if (statusId === '1') {
      return (<span className='label label-success'>อนุมัติแล้ว</span>)
    } else if (statusId === '2') {
      return (<span className='label label-primary'>ได้รับของแล้ว</span>)
    } else if (statusId==='3') {
      return (<span className="label label-success" >นำเข้าสต็อกเรียบร้อย</span>)
    } else if (statusId==='4') {
      return (<span className="label label-success" >นำไปซ่อมแล้ว</span>)        
    } else {
      return (<span />)
    }

  }

  renderStatus2(statusId){
    let {status} = this.state

    let title = ''
    status.forEach(element => {
      if(element.statusId*1===statusId*1){
        title = element.title
      }
    });

    return (<span>{title}</span>)
  }

  renderType(){
    
  }

  renderRowData() {
    let {data,itemTypes} = this.state
    if (data.dataList.length===0) {
      return(
        <tr><td colSpan={21}>ไม่พบข้อมูล</td></tr>
      )
    } else {
      let optionsSelect = itemTypes.map((item,index)=>{
        return {label:item.title,value:item.itemTypeId}
      })
      return(
        data.dataList.map((item,index) => {
          let disabled = (item.id*1===-1)
          let _PO = (<div></div>)
          if (item.purchaseOrder!==''&&item.purchaseOrder!==null) {
            let hover = (
                <Popover id="popover-positioned-right" title={item.purchaseOrder}>
                  <strong>คลิ๊กตรงไอค่อนเพื่อเข้าดูงาน</strong>
                </Popover>
            )  
            _PO = (
              <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={hover}>
                <div onClick={this.onRowSelect.bind(this,item)} ><FontAwsome name='file-text' className='color-blue' />&nbsp;{item.purchaseOrder}</div>
              </OverlayTrigger>
            )
          }
          return(
            <tr key={index} className={disabled?'bg-yellow':''}>
              <td style={{verticalAlign:'middle'}} className='text-center'>{index+1}</td>
              <td style={{verticalAlign:'middle'}}>
                <FormControl 
                  disabled={disabled}
                  value={item.productcode} 
                  onChange={this.onInputChange.bind(this,index,'productcode')} 
                /> 
              </td>
              <td style={{verticalAlign:'middle'}}>
                <FormControl 
                  disabled={disabled}
                  value={item.itemName} 
                  onChange={this.onInputChange.bind(this,index,'itemName')} 
                /> 
              </td>
              <td style={{verticalAlign:'middle'}}>
                <FormControl 
                  disabled={disabled}
                  style={{textAlign:'center'}}
                  value={item.quantity} 
                  onChange={this.onInputChange.bind(this,index,'quantity')} 
                />
              </td>
              <td style={{verticalAlign:'middle'}}>
                <Select 
                  disabled={disabled}
                  clearable={false} 
                  name="form-field-name" 
                  value={item.itemTypeId} 
                  options={optionsSelect} 
                  onChange={this.onTypeChange.bind(this,index)} 
                />                
              </td>
              <td style={{verticalAlign:'middle'}}>
                <Select 
                  disabled={disabled}
                  clearable={false} 
                  name="form-field-name" 
                  value={item.part_by} 
                  options={[{label:'อู่',value:'garage'},{label:'สาขา',value:'branch'},{label:'ประกัน',value:'insurance'},{label:'ลูกค้า',value:'customer'}]} 
                  onChange={this.onPartByChange.bind(this,index)} 
                />                
              </td>
              <td style={{verticalAlign:'middle'}}>
                <Select 
                  disabled={disabled}
                  placeholder='เลือก'
                  clearable={true} 
                  name="form-field-name" 
                  value={item.part_dispose_by} 
                  options={this.state.part_dispose} 
                  onChange={this.onPartDisposeByChange.bind(this,index)} 
                />         
              </td>
              <td style={{verticalAlign:'middle'}} className='text-center'>
                    <Checkbox
                      onChange={this.onPendingInstallChange.bind(this,index,item.is_pending_install)}
                      checked={item.is_pending_install==='1'?true:false}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"                  
                    /> 
              </td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{item.shopName}</td>
              <td style={{verticalAlign:'middle'}} className='text-right'>{numberFormat("#,##0.##",item.po_amount_before_discount)}</td>
              <td style={{verticalAlign:'middle'}} className='text-right'>{numberFormat("#,##0.##",item.po_discount)}</td>
              <td style={{verticalAlign:'middle'}} className='text-right'>{numberFormat("#,##0.##",item.po_amount)}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{_PO}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{item.issueDate}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{item.approved_date}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{item.po_received_date}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{item.exportwork_date}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{item.import_stock_date}</td>
              <td style={{verticalAlign:'middle'}} className='text-right'>{item.payment_date}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{this.renderStatus(item.statusId)}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>
                <FormControl
                  disabled={disabled}
                  value={item.remark} 
                  onChange={this.onInputChange.bind(this,index,'remark')}
                />
              </td>
            </tr>
          )
        })
      )
    }
  }

  renderNewItemButton(){
    return (
      <div style={{display:"inline-flex"}}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwsome name='plus'/>&nbsp;เพิ่มแถว</Button>
          <Button bsStyle='primary' onClick={this.onPullLatestQuotation.bind(this)}><FontAwsome name='download'/>&nbsp;ดึงข้อมูลใบเสนอราคาล่าสุด</Button>
        </ButtonToolbar> 
        &nbsp;
        <div className='bg-yellow'> * แถบสีนี้ หมายถึงสั่งอะไหล่นอกเหนือจากการสั่งซ่อม </div>    
      </div>
    )
  }

  newEmptyRow(number=1) {
    return new Array(number).fill(null).map((item,index)=>{
      return {
            id:'',
            itemName:'',
            quantity:'',
            itemTypeId:'0',
            shopName:'',
            shopId:'',
            purchaseOrder:'',
            issueDate:'',
            statusId:'-1',
            remark:'',
            po_received_date:'',
            po_amount_before_discount:'',
            po_discount:'',
            po_amount:'',
            exportwork_date:'',
            payment_date:'',
            amount:'',
            part_by:'garage',
            part_dispose_by:'',
            is_pending_install:'0',
            productcode:''
      }
    })
  }

  onRowAdd(number,e) {
    let {data} = this.state
    data.dataList = data.dataList.concat(this.newEmptyRow(number))
    
    this.pcInput = new Array(data.dataList.length).fill('')
    this.setState({data:data})
  }

  onRowDelete(index,e) {
    let {data} = this.state
    data.dataList.splice(index, 1)
    this.setState({data:data})
  }

  onInputChange(index,key,e) {
    let {data} = this.state
    data.dataList[index][key] = e.target.value
    this.setState({data:data})
  }

  onPendingInstallChange(index,val) {
    let {data} = this.state
    if (val==='1')
      data.dataList[index]['is_pending_install'] = '0'
    else
      data.dataList[index]['is_pending_install'] = '1'  
    this.setState({data:data})
  }

  onTypeChange(index,e) {
    let {data} = this.state
    data.dataList[index]['itemTypeId'] = e.value
    this.setState({data:data})
    $('.table-responsive').css( "overflow-x", "auto" );
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onPageChange(page) {
    //console.log('pageChagne', page)
  }

  onPrintClick() {
    let {workNo} = this.props
    let url = './pdf/v2/?startPage=PrintReportWorkDocPurchaseOrder&wo='+workNo
    if (process.env.NODE_ENV === "development") {
      url = './?startPage=PrintReportWorkDocPurchaseOrder&wo='+workNo   
    }
    this.refs.iframe.loadUrl(url)
  }

  onMenuItemSelect(index) {
    if ("receivestatus" === index) {
      this.setState({showPOR:true})      
    } else if ("returnstatus" === index) {
      this.setState({showPOT:true})      
    } else if ("exportworkstatus" === index) {  
      this.setState({showPOE:true})
    } else if ("importstock" === index) {      
      this.setState({showPOI: true })      
    }
  }

  onSavePORecord(recordType,header){
    let {doc} = this.state
    if(recordType==='EXPORTWORK'){
      doc.exportwork_date = header.date
    }else if(recordType==='RECEIVED'){
      doc.received_date = header.date
    }else if(recordType==='IMPORT_STOCK'){
      doc.importstock_date = header.date
    }
    this.setState({doc:doc})
  }

  onAfterReceivedClick(items) {
    let {data} = this.state
    let checkItemnum = []
    items.forEach(function(item,index) {
      checkItemnum.push(item.bf_work_damage_id)
    })
    data.dataList.forEach(function(item,index) {
      if (checkItemnum.indexOf(item.id)!==-1) {
        data.dataList[index].po_received_date = TODAY
      }
    })
    this.setState({data:data})
    this.onSaveClick()
  }

  onAfterExportWorkClick(items) {
    let {data} = this.state
    let checkItemnum = []
    items.forEach(function(item,index) {
      checkItemnum.push(item.bf_work_damage_id)
    })
    data.dataList.forEach(function(item,index) {
      if (checkItemnum.indexOf(item.id)!==-1) {
        data.dataList[index].exportwork_date = TODAY
      }
    })
    this.setState({data:data})
    this.onSaveClick()
  }

  onAfterPOImportClick(items) {
    let {data} = this.state
    let checkItemnum = items.map((item,index)=> {
      return item.bf_work_damage_id
    })
    data.dataList.forEach(function(item,index) {
      if (checkItemnum.indexOf(item.id)!==-1) {
        data.dataList[index].import_stock_date = TODAY
      }
    })
    this.setState({data:data})
    this.onSaveClick()
  }

  onAfterReturnClick(items) {
    let {data} = this.state
    let checkItemnum = []
    items.forEach(function(item,index) {
      checkItemnum.push(item.bf_work_damage_id)
    })
    checkItemnum.forEach(function(item,index) {
      data.dataList.splice(data.dataList.map(function(e) { return e.id; }).indexOf(item), 1)
    })
    this.setState({data:data})
    this.onSaveClick()
  }

  onAutoCreateStockClick(items) {
    let {data} = this.state
    items.forEach((item,index)=>{
      const key = data.dataList.findIndex(x=>x.id===item.bf_work_damage_id)
      if (key!==-1) {
        data.dataList[key] = Object.assign(data.dataList[key], {itemnum:item.itemnum,stock_type:item.stock_type})
      }
    })
    this.setState({data:data})
    this.onSaveClick()
  }

  renderPaging() {
    // let { pageCount, activePage } = this.state
    return (
      <Row>
        <Col md={12} >
          <ReactPaginate
            previousLabel={"ก่อนหน้า"}
            nextLabel={"ถัดไป"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.onPageChange.bind(this)}
            containerClassName={"pagination pull-right"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </Col>
      </Row>
    )
  }

  render() {
    const title = typeof this.props.title !== 'undefined' ? 'ตาราง' + this.props.title : ''
    let ddTitle = (<span><FontAwsome name='list' /> ทางเลือก</span>)
    let {showShop,showTable,doc,data,showPOT,showPOE,showPOR,showPOI} = this.state
    return(
      <div>
        <div style={{display:showTable?'block':'none'}}>
          <Box loading={this.state.loading}>
            <Box.Header border={true}>
              <Box.Title>{title}</Box.Title>
              <Box.Tools className='pull-right'>
                <button onClick={this.onPrintClick.bind(this)} className='btn bg-maroon'><FontAwsome name='print' />&nbsp;พิมพ์เอกสาร</button>
                &nbsp;
                <DropdownButton style={{display:(this.props.showMenu?"":"none")}} bsStyle={'primary'} title={ddTitle} id={'workdoc-po-menu-options'} onSelect={this.onMenuItemSelect.bind(this)}>
                  <MenuItem eventKey="receivestatus"><FontAwsome name='thumbs-o-up' className='text-black' />&nbsp;รับสินค้า</MenuItem>
                  <MenuItem eventKey="returnstatus"><FontAwsome name='thumbs-o-down' className='text-red' />&nbsp;คืนสินค้า</MenuItem>
                  <MenuItem divider />
                  <MenuItem eventKey="exportworkstatus"><FontAwsome name='wrench' className='text-black' />&nbsp;เบิกไปซ่อม</MenuItem>
                  <MenuItem divider />
                  <MenuItem eventKey="importstock"><FontAwsome name='industry' className='text-black' />&nbsp;นำสินค้าเข้าคลัง</MenuItem>
                </DropdownButton>
              </Box.Tools>
            </Box.Header>
            <Box.Body>
              {this.renderTable()}
              {this.renderNewItemButton()}           
            </Box.Body>
            <Box.Footer>
              <div className='pull-right'>
                <Button bsStyle="primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save'/>&nbsp;บันทึก</Button>
              </div>  
            </Box.Footer>
          </Box>
        </div>  
        <div style={{display:!showTable?'block':'none'}}>
          <Breadcrumb>
            <Breadcrumb.Item href="#" onClick={this.onDocClose.bind(this)}><FontAwsome name="table"/> ตารางใบสั่งซื้อ</Breadcrumb.Item>
            <Breadcrumb.Item href="#" active>
              <FontAwsome name='file-o'/> ใบสั่งซื้อ {this.state.poNo}
            </Breadcrumb.Item>            
          </Breadcrumb>
          <PurchaseOrderDoc ref='poDoc' onClose={this.onDocClose.bind(this)}/>
        </div>
        <SupplierPageModal show={showShop} onHide={() => { this.setState({ showShop: false }) }}
          onSelect={this.onSupplierPageSelect.bind(this)}
        />       
        <NotificationSystem ref="notificationSystem" />  
        <IframeModal ref='iframe' title='พิมพ์เอกสาร' />
        <POOutstandingRecordModal 
          show={showPOR} 
          onHide={()=>{this.setState({showPOR:false})}}
          workNo={this.props.workNo}
          data={data.dataList}
          mode='workdoc-po'
          doc={doc}
          recordType={'RECEIVED'}
          title='รับของ'
          onSavePORecord={this.onSavePORecord.bind(this,'RECEIVED')}
          onAfterReceivedClick={this.onAfterReceivedClick.bind(this)}
        />
        <POOutstandingRecordModal 
          show={showPOT} 
          onHide={()=>{this.setState({showPOT:false})}}
          workNo={this.props.workNo}
          data={data.dataList}
          mode='workdoc-po'
          doc={doc}
          recordType={'RETURN'}
          title='คืนสินค้า'
          onSavePORecord={this.onSavePORecord.bind(this,'RETURN')}
          onAfterReturnClick={this.onAfterReturnClick.bind(this)}
        />
        <POOutstandingRecordModal 
          show={showPOE} 
          onHide={()=>{this.setState({showPOE:false})}}
          workNo={this.props.workNo}
          data={data.dataList}
          mode='workdoc-po'
          doc={doc}
          recordType={'EXPORTWORK'}
          title='เบิกไปซ่อม'
          onSavePORecord={this.onSavePORecord.bind(this,'EXPORTWORK')}
          onAfterExportWorkClick={this.onAfterExportWorkClick.bind(this)}
        />
        <POOutstandingRecordModal show={showPOI} 
          onHide={()=>{this.setState({showPOI:false})}}
          workNo={this.props.workNo}
          data={data.dataList}
          mode='workdoc-po'
          doc={doc}
          recordType={'IMPORT_STOCK'}
          title='นำสินค้าเข้าคลัง'
          onSavePORecord={this.onSavePORecord.bind(this,'IMPORT_STOCK')}
          onAfterImportStockClick={this.onAfterPOImportClick.bind(this)}
          onAutoCreateStockClick={this.onAutoCreateStockClick.bind(this)}
        />
      </div>  
    )
  }
}

WorkDocPurchaseOrder.defaultProps = {  
  showMenu:false
}

export default WorkDocPurchaseOrder;   


// WEBPACK FOOTER //
// ./src/view/workdoc/WorkDocPurchaseOrder.js